import React, { useEffect, useState, useContext } from "react";
import {
  TextField,
  FormLabel,
} from "@material-ui/core";
import MainContext from "../../context/main/mainContext";
import dates from "../../utilities/dates";

const ExtendTrialButton = ({ internalDemoTeam, setIsLoading }) => {
  const mainContext = useContext(MainContext);
  const { updateDemoTeam } = mainContext;
  const [trialDate, setTrialDate] = useState(null);
  const [isDisabled, setIsDisabled] = useState(null);

  const handleSetTrialDate = (e) => {
    if (e.target.value.includes(" ")) {
      return;
    }
    setTrialDate(e.target.value);
    setIsDisabled(dates.getDaysBetween(new Date(), e.target.value) < 0);
  };

  const handleExtendTrial = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const trialDays = dates.getDaysBetween(new Date(), trialDate);

    await updateDemoTeam(internalDemoTeam?.id, { trialDays });
    setIsLoading(false);
  };

  useEffect(() => {
    setTrialDate(dates.formatTrialEnd(internalDemoTeam?.trialExpiresAtUtc));
    setIsDisabled(
      dates.getDaysBetween(new Date(), internalDemoTeam?.trialExpiresAtUtc.split("T")[0]) < 0,
    );
  }, [internalDemoTeam]);

  return (
    <form onSubmit={handleExtendTrial}>
      <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
        <FormLabel>Trial End Date</FormLabel>
        <TextField
          variant="outlined"
          required="true"
          onChange={handleSetTrialDate}
          value={trialDate}
          type="date"
        />

        <button
          disabled={isDisabled}
          className="buttonContainerAlt"
          style={isDisabled ? { backgroundColor: "lightgray", cursor: "default" } : {}}
        >
          Extend Trial
        </button>
      </div>
    </form>
  );
};

export default ExtendTrialButton;
